import api from "./api";
import { ModifierType } from "../components/References/Modifier/ModifierType";
export type DeletModifierDto = {
  id: number | string;
};

/*Search & filter */

export const getmodifiersApi = async (body: {
  limit: number;
  q: string;
  isActive?: boolean;
}) => {
  let url = `/modifiers?limit=${body.limit}&q=${body.q.toString()}`;

  if (body.isActive !== undefined) {
    url += `&isActive=${body.isActive}`;
  }

  return await api.get(url);
};


/*delete Modifier */

export const deleteModifier = async (dto: DeletModifierDto) => {
  return await api.delete(`/modifiers/${dto.id}`);
};

/* Modifier By id*/

export const getModifierById = async (modifierId: string | undefined) => {
  return await api.get(`/modifiers/${modifierId}`);
};

/*create Modifier */

export const createModifier = async (modifierDetails: ModifierType) => {
  return await api.post("/modifiers", modifierDetails);
};

/*edit Modifier */

export const editModifier = async (modifierId: any, body: ModifierType) => {
  return await api.put(`/modifiers/${modifierId}`, body);
};

/*Modifier Select*/

export const getmodifiersDropdown = async () => {
  return await api.get("/modifiers/dropdown");
};
